import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faClock,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";

const Welcome = ({
  date,
  formatDate,
  title,
  img,
  readingTime,
  isEnglish,
}) => {
  const bgImage = img ? `url("${img}")` : "url('/img/homeBkg.jpg')";

  return (
    <header
      className="hero news-details-hero align-bottom"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(9, 12, 30, 0.75) 0%, rgba(9, 12, 30, 0.88) 60%, rgba(9, 12, 30, 0.98) 100%), ${bgImage}`,
      }}
    >
      <div className="container text-left py-4">
        <div className="news-hero-inner">
          <div className="mb-3">
            <span className="article-category-badge">
              <FontAwesomeIcon icon={faNewspaper} className="me-2" />
              {isEnglish ? "Press & News" : "Comunicato & Notizie"}
            </span>
          </div>

          <h1 className="news_details_title mb-3 text-capitalize">{title}</h1>

          <div className="news_details_meta d-flex align-items-center flex-wrap gap-3">
            {date && (
              <span className="meta-item text-warning font-weight-bold">
                <FontAwesomeIcon icon={faCalendar} className="me-2 text-warning" />
                <span>{formatDate(date)}</span>
              </span>
            )}
            {readingTime && (
              <>
                <span className="text-muted opacity-75 d-none d-sm-inline">•</span>
                <span className="meta-item text-light opacity-90 small">
                  <FontAwesomeIcon icon={faClock} className="me-1 text-warning" />
                  <span>
                    {readingTime} {isEnglish ? "min read" : "min di lettura"}
                  </span>
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Welcome;
